import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig, isFeatureAvailable } from 'platformConfig'

export type PlatformProductConfig = {
  regularMemberships: boolean
  subscriptionMemberships: boolean
  regularExtensions: boolean
  pauseTokens: boolean
  additionalTests: boolean
}

const REGULAR_PRODUCTS: PlatformProductConfig = {
  regularMemberships: true,
  subscriptionMemberships: false,
  regularExtensions: true,
  pauseTokens: true,
  additionalTests: true,
}

export const PRODUCTS_CONFIG: Partial<Record<PlatformSlug, PlatformProductConfig>> = {
  [PlatformSlug.DATBooster]: REGULAR_PRODUCTS,
  [PlatformSlug.OATBooster]: REGULAR_PRODUCTS,
  [PlatformSlug.DATCrusher]: REGULAR_PRODUCTS,
  [PlatformSlug.INBDEBooster]: { ...REGULAR_PRODUCTS, additionalTests: false },
  [PlatformSlug.NBDHEBooster]: { ...REGULAR_PRODUCTS, additionalTests: false },
  [PlatformSlug.NDEBCrusher]: { ...REGULAR_PRODUCTS, additionalTests: false, pauseTokens: false },
  [PlatformSlug.CasperBooster]: { ...REGULAR_PRODUCTS, additionalTests: false },
  [PlatformSlug.PATBooster]: {
    regularMemberships: false,
    subscriptionMemberships: true,
    regularExtensions: false,
    pauseTokens: false,
    additionalTests: true,
  },
  [PlatformSlug.CARSBooster]: {
    regularMemberships: true,
    subscriptionMemberships: true,
    regularExtensions: false,
    pauseTokens: false,
    additionalTests: false,
  },
  [PlatformSlug.DLOSCE]: { ...REGULAR_PRODUCTS, additionalTests: false, pauseTokens: false },
  [PlatformSlug.GREBooster]: { ...REGULAR_PRODUCTS, additionalTests: false },
}

export const getPlatformProductConfig = (slug?: PlatformSlug) => getFeatureConfig(PRODUCTS_CONFIG, slug)
export const isProductsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(PRODUCTS_CONFIG, slug)
export const isMembershipsAvailable = (slug?: PlatformSlug) => {
  const config = getPlatformProductConfig(slug)
  return Boolean(config?.regularMemberships || config?.subscriptionMemberships)
}
